import React, { useEffect, useState } from 'react';
import Search from '../../components/input/Search';
import { searchArticles } from '../../api/sportaloka-client';
import ArticleTable from './components/ArticleTable';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

function Article() {
  const [articles, setArticles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    title: ''
  });

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setArticles([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        title: paginationOptions.title
      }).toString();
      const response = await searchArticles(query);
      const responseData = response.data.data.data;
      setArticles(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleSort = (field) => {
    const isAsc = paginationOptions.sort_field === field && paginationOptions.sort_value === 'asc';
    setPaginationOptions({
      ...paginationOptions,
      sort_field: field,
      sort_value: isAsc ? 'desc' : 'asc',
      page: 1
    });
  };

  const handleSearch = (val) => {
    setPaginationOptions({ ...paginationOptions, title: val, page: 1 });
  };

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Artikel</h1>
          <Link to="/article/create" className="button -md h-50 bg-blue-1 text-white">
            <i className="fa fa-plus mr-10" />
            Buat Artikel
          </Link>
        </div>
        <div className="row mt-20">
          <div className="col-12">
            <Search onSearch={handleSearch} label="Judul Artikel" />
          </div>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20">
          <ArticleTable
            handleSort={handleSort}
            handlePageChange={handlePageChange}
            handleRefresh={getData}
            paginationOptions={paginationOptions}
            loading={loading}
            error={error}
            data={articles}
            totalRows={totalRows}
          />
        </div>
      </div>
      {/* End .col-12 */}
    </div>
  );
}

export default Article;
